// @flow
import client from '../../client'
import { config } from '../../config'

type StripOrigin = string

export type Options = {
  amount: number,
  currency: string,
  stripe_origin: StripOrigin,
  search_id: string,
  result_id: string,
}

export type PaymentIntentData = {
  stripe_origin: StripOrigin,
  client_secret: string,
  amount: number,
  paymentintent_id: string,
  currency: string,
  customer: string,
}

export const CREATE_INTENT_ENDPOINT = '/stripe_payments/'

export const createPaymentIntent = (
  body: Options
): Promise<PaymentIntentData> =>
  client.post(CREATE_INTENT_ENDPOINT, {
    body,
    baseUrl: config.BASE_URL_PAYMENTS,
  })

export default createPaymentIntent
